/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/glass-house-shelf-talker-post-card-content/glass-house-shelf-talker-post-card-content.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=glass-house-shelf-talker-post-card-content.component.css.map */
